import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Legacy /card/:customer_id route — replaced by the standalone
 * DiscountMiniApp at /d/:shop. Kept so older home-screen shortcuts keep
 * working: fetch the card to learn its shop_slug, prime localStorage so
 * the mini-app auto-loads the customer's card, then redirect.
 */
export default function PublicCard() {
    const { customer_id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const r = await axios.get(`${API}/public/card/${customer_id}`);
                if (!alive) return;
                const slug = (r.data?.shop_slug || "humairi").toLowerCase();
                try { localStorage.setItem(`${slug}_customer_id`, customer_id); } catch {/* */}
                navigate(`/d/${slug}`, { replace: true });
            } catch {
                if (alive) navigate("/d/humairi", { replace: true });
            }
        })();
        return () => { alive = false; };
    }, [customer_id, navigate]);

    return (
        <div className="flex min-h-screen items-center justify-center bg-neutral-100" dir="rtl">
            <Loader2 className="h-8 w-8 animate-spin text-amber-700" />
        </div>
    );
}
